export default __webpack_public_path__ + "static/media/governor-spinner.ebda823e.gif";